export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
];

// Free-tier caps are 5/5/3 (not the ISC2-standard 10/10/3): the CC bank is small
// (147 questions; domain 3 has only 12), so 10 per domain would give away a third of it.
export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Security Principles',
        exam_weightage: 24,
        show_proficiency: true,
        icon: 'shield-check',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'Security Governance',
        exam_weightage: 17.3,
        show_proficiency: true,
        icon: 'clipboard-list',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'Identity and Access Management (IAM) Concepts',
        exam_weightage: 20,
        show_proficiency: true,
        icon: 'fingerprint',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'Networking and Cloud Security Concepts',
        exam_weightage: 21.3,
        show_proficiency: true,
        icon: 'security-network',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 5,
        domain_name: 'Security Operations and Incident Response',
        exam_weightage: 17.3,
        show_proficiency: true,
        icon: 'shield-sync',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
];

export const QUESTION_VERSION_OF_JSON = 1
